module.exports = __webpack_public_path__ + "img/molitfelnic-1635-prefata-big.7028fef4.png";